export default {
  appUpdateAvailable: 'App update is available',
  update: 'Update',
  noNpeAccess: 'You seem lost...\n in life\nfollow the light...\n it guides\n\nhttps://www.quickytools.com'
}
